import React from "react";
import { ShieldAlert, Lock } from "lucide-react";

const PHI_ITEMS = [
  "Patient names",
  "DOBs",
  "Member IDs",
  "SSNs",
  "Addresses",
  "Phone numbers",
  "Email addresses",
  "Medical record numbers",
];

export const PHIWarning = ({ compact = false }) => (
  <div
    data-testid="phi-warning-banner"
    className={`rounded-xl border-l-4 border-amber-500 bg-amber-50 ${compact ? "p-3" : "p-5 sm:p-6"} flex gap-4 items-start`}
  >
    <div className="shrink-0 h-10 w-10 rounded-lg bg-amber-500/15 flex items-center justify-center">
      <ShieldAlert className="h-5 w-5 text-amber-700" />
    </div>
    <div className="flex-1">
      <div className="flex items-center gap-2">
        <Lock className="h-3.5 w-3.5 text-amber-700" />
        <span className="text-[11px] font-semibold tracking-[0.14em] uppercase text-amber-700">PHI Upload Restrictions</span>
      </div>
      <p className="mt-2 text-sm text-amber-900 leading-relaxed font-medium">
        This platform only accepts <strong>de-identified operational revenue cycle and denial data</strong>.
      </p>
      {!compact && (
        <>
          <p className="mt-3 text-sm text-amber-900 font-semibold">Do NOT upload files containing:</p>
          <ul className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 text-sm text-amber-900">
            {PHI_ITEMS.map((item) => (
              <li key={item} className="flex items-start gap-2">
                <span className="text-amber-700 mt-0.5">•</span>{item}
              </li>
            ))}
          </ul>
          <p className="mt-3 text-xs text-amber-800 font-medium">
            Files containing PHI will be automatically rejected.
          </p>
        </>
      )}
    </div>
  </div>
);
